import { NormativaI } from "interfaces/Normativa";
import { ValidezNacionalI } from "interfaces/ValidezNacionalI";
import { EstadoValidacionNacionalI } from "interfaces/EstadoValidacionNacional";
import { PlanEstudioI } from "interfaces/PlanEstudio";

export interface infoFetchGetValidezNacional {
  id: number | string;
  fechaAprobacion: Date | null;
  fechaCaducidad: Date | null;
  planEstudio: PlanEstudioI;
  normativa: NormativaI;
  estado: EstadoValidacionNacionalI;
  expedienteInterno: number | string;
  expedienteNacional: number | string;
}

class ValidezNacional implements ValidezNacionalI {
  id: number | string;
  fechaAprobacion: Date | null;
  fechaCaducidad: Date | null;
  planEstudio: PlanEstudioI;
  normativa: NormativaI;
  estado: EstadoValidacionNacionalI;
  expedienteInterno: number | string;
  expedienteNacional: number | string;

  constructor(infoFetch: infoFetchGetValidezNacional) {
    this.id = infoFetch.id;
    this.fechaAprobacion = infoFetch.fechaAprobacion
      ? new Date(infoFetch.fechaAprobacion)
      : null;

    this.fechaCaducidad = infoFetch.fechaCaducidad
      ? new Date(infoFetch.fechaCaducidad)
      : null;
    this.planEstudio = infoFetch.planEstudio;
    this.normativa = infoFetch.normativa;
    this.estado = infoFetch.estado;
    this.expedienteInterno = infoFetch.expedienteInterno;
    this.expedienteNacional = infoFetch.expedienteNacional;
  }
}

export const makeValidezNacional = (infoFetch: infoFetchGetValidezNacional) => {
  console.log("Validez Nacional", { infoFetch });
  return new ValidezNacional(infoFetch);
};
